import React, { useEffect } from 'react';
import styled from 'styled-components';
import SectionHeader from '../components/SectionHeader';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import project1 from '../assets/images/project1.jpg';
import project2 from '../assets/images/project2.jpg';
import project3 from '../assets/images/project3.jpg';

const ProjectsSection = styled.main`
  min-height: 100vh;
  background-color: var(--dark-color);
  padding: 120px 0 80px;
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 50px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ProjectCard = styled.div`
  background-color: var(--bg-color);
  border: 1px solid var(--primary-color);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  transition-delay: ${props => props.delay || '0s'};
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
  }
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
    border-color: var(--secondary-color);
  }
`;

const ProjectImage = styled.div`
  height: 200px;
  background-color: var(--grey-color);
  background-size: cover;
  background-position: center;
  background-image: url(${props => props.image});
`;

const ProjectInfo = styled.div`
  padding: 20px;
  
  h3 {
    color: var(--secondary-color);
    margin-bottom: 10px;
  }
`;

const CenterButton = styled.div`
  text-align: center;
  margin-top: 40px;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  transition-delay: 0.6s;
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Projects = () => {
  useEffect(() => {
    const handleScroll = () => {
      const projectCards = document.querySelectorAll('.project-card');
      const centerButton = document.querySelector('.center-button');
      
      projectCards.forEach(card => {
        const position = card.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        if (position.top < windowHeight * 0.75) {
          card.classList.add('animate');
        }
      });
      
      if (centerButton) {
        const position = centerButton.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        if (position.top < windowHeight * 0.9) {
          centerButton.classList.add('animate');
        }
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    // Initial check
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const projects = [
    {
      id: 1,
      title: 'Sistema de Gestão Tática',
      description: 'Plataforma completa para gerenciamento empresarial com dashboard estratégico.',
      image: project1,
      delay: '0s'
    },
    {
      id: 2,
      title: 'App de Rastreamento',
      description: 'Aplicativo móvel para monitoramento de ativos e equipes em tempo real.',
      image: project2,
      delay: '0.2s'
    },
    {
      id: 3,
      title: 'Portal de Comércio Digital',
      description: 'E-commerce avançado com integração de pagamentos e logística.',
      image: project3,
      delay: '0.4s'
    },
    {
      id: 4,
      title: 'Dashboard Analítico',
      description: 'Visualização de dados em tempo real com métricas personalizáveis e alertas.',
      image: project1,
      delay: '0.2s'
    },
    {
      id: 5,
      title: 'Sistema de Segurança',
      description: 'Monitoramento avançado e registro de atividades para proteção de ativos digitais.',
      image: project3,
      delay: '0.4s'
    },
    {
      id: 6,
      title: 'Aplicativo de Comunicação',
      description: 'Plataforma segura para troca de mensagens e compartilhamento de arquivos.',
      image: project2,
      delay: '0.6s'
    }
  ];
  
  return (
    <ProjectsSection>
      <div className="container">
        <SectionHeader title="Nossos Projetos" highlight="Projetos" />
        <ProjectsGrid>
          {projects.map((project) => (
            <ProjectCard 
              key={project.id} 
              className="project-card"
              delay={project.delay}
            >
              <ProjectImage image={project.image} />
              <ProjectInfo>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
              </ProjectInfo>
            </ProjectCard>
          ))}
        </ProjectsGrid>
        <CenterButton className="center-button">
          <Link to="/contact">
            <Button>Iniciar um Projeto</Button>
          </Link>
        </CenterButton>
      </div>
    </ProjectsSection>
  );
};

export default Projects;
